import axios from 'axios'
import {LabelsQueryResponse} from './_models'

const API_URL = process.env.REACT_APP_API_URL;

const getLabels = (filter: any): Promise<LabelsQueryResponse> => {

    return axios.post(`${API_URL}/SearchLabelServlet`, filter)
    .then((res) => {
        // conform output to { data, payload } object.
        return {data : [res.data], payload : {}};
    })
    .catch((err) => {
        return {data: [], payload: {}}
    })         
}


const getLabelById = (id : number) => {
    // get label record
    return axios.post<any>(`${API_URL}/GetLabelServlet`,  id, { headers: { "Content-Type": "text/plain" }} )
    .then((res) => {        
        return res.data;
    })        
}


export {getLabels, getLabelById}
